
































































import { mapGetters } from "vuex";
import Login from "@/views/Home/LoginForm.vue";
import SimpleNavigation from "@/components/SimpleNavigation";
import ConsultProcess from "@/views/Home/ConsultProcess.vue";

import LOGO from "@/assets/images/LOGIN_LOGO.png";
import govSuiteLogo from "@/assets/images/seplagLogoWhite.svg";
import govSuiteColored from "@/assets/images/GOV_SUITE_COLORED.png";
import govSuiteWhite from "@/assets/images/APP_HEADER_LOGO.png";

import { App, Home, General } from "@/utils/constants";

export default {
  name: "WrapLogin",
  components: {
    Login,
    SimpleNavigation,
    ConsultProcess
  },
  data() {
    return {
      App,
      Home,
      General,
      LOGO,
      govSuiteLogo,
      govSuiteColored,
      govSuiteWhite
    };
  },
  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    }),
    isBeta() {
      return process.env.VUE_APP_ENVIRONMENT === "beta";
    },
    isQA() {
      return process.env.VUE_APP_ENVIRONMENT === "qa";
    }
  }
};
